var map = {
	"./calc-characterpunisher.md": [
		2182,
		182
	],
	"./calc-framekillgenerator.md": [
		9109,
		109
	],
	"./calc-frametrapchecker.md": [
		3394,
		394
	],
	"./calc-frametraplister.md": [
		3856,
		856
	],
	"./calc-movelinker.md": [
		1407,
		7
	],
	"./calc-movepunisher.md": [
		7703,
		703
	],
	"./calc-stringinterrupter.md": [
		4158,
		158
	],
	"./calculators.md": [
		5677,
		677
	],
	"./combos.md": [
		7820,
		820
	],
	"./framedata.md": [
		8720,
		720
	],
	"./moveslist.md": [
		5521,
		521
	],
	"./settings.md": [
		7261,
		261
	],
	"./statcompare.md": [
		6153,
		153
	],
	"./yaksha.md": [
		6410,
		410
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4887;
module.exports = webpackAsyncContext;